import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export type BvBadgeVariant =
  | "default"
  | "brand"
  | "success"
  | "error"
  | "warning"
  | "info";

/**
 * Pill badge. Mirrors design-system.html .badge.
 *
 *   <bv-badge>5</bv-badge>
 *   <bv-badge variant="success" [dot]="true">Live</bv-badge>
 */
@Component({
    selector: "bv-badge",
    template: "<ng-content></ng-content>",
    styleUrls: ["./badge.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-badge",
        "[class.bv-badge--default]": 'variant === "default"',
        "[class.bv-badge--brand]": 'variant === "brand"',
        "[class.bv-badge--success]": 'variant === "success"',
        "[class.bv-badge--error]": 'variant === "error"',
        "[class.bv-badge--warning]": 'variant === "warning"',
        "[class.bv-badge--info]": 'variant === "info"',
        "[class.bv-badge--dot]": "dot",
    }
})
export class BvBadgeComponent {
  @Input() variant: BvBadgeVariant = "default";
  @Input() dot = false;
}
